(ns hai.admin-ui.setup
  #?(:cljs (:require-macros hai.admin-ui.setup))
  #?(:cljs
     (:require
      [clojure.string :as str]
      [hai.ui.components :as c]
      [hai.ui.components.new-design.utils :refer [px->rem]]
      [hai.ui.icons :as icons]
      [hai.ui.rf-sugar :refer [>e]]
      [hai.ui.tokens :as t]
      [hai.web-app.layout :as layout]
      [lambdaisland.ornament :as o]
      [reagent.core :as r]
      [url.install :as install])
     :clj
     (:require
      [clojure.string :as str]
      [hai.ui.components.new-design.utils :refer [px->rem]]
      [hai.ui.icons :as icons]
      [hai.ui.tokens :as t]
      [lambdaisland.ornament :as o])))

;; ── "Book a call" button ─────────────────────────────────────────────────────

(o/defstyled book-a-call :a
  :inline-flex :items-center
  {:gap             (px->rem 7)
   :font-size       (px->rem 13)
   :font-weight     "700"
   :color           t/--hai-dark-purple
   :background      "white"
   :border          "1.5px solid #DAD2CE"
   :padding         (str/join " " [(px->rem 8) (px->rem 16)])
   :border-radius   (px->rem 8)
   :text-decoration "none"
   :white-space     "nowrap"
   :flex-shrink     "0"
   :transition      "all 0.2s"}
  [:&:hover {:border-color t/--hai-dark-purple
             :background   t/--hai-dark-purple
             :color        "white"}]
  [:svg {:flex-shrink "0"}])

;; ── Title row ────────────────────────────────────────────────────────────────

(o/defstyled title-row :div
  :flex :items-center
  {:justify-content "space-between"
   :gap             (px->rem 16)
   :margin-bottom   (px->rem 8)})

(o/defstyled title-icon-group :div
  :flex :items-center
  {:gap (px->rem 12)})

(o/defstyled page-title :h1
  {:font-size   (px->rem 30)
   :font-weight "800"
   :color       t/--hai-dark-purple
   :line-height "1.15"
   :margin      "0"})

;; ── Lead paragraph ───────────────────────────────────────────────────────────

(o/defstyled page-lead :p
  {:font-size     (px->rem 14)
   :color         "#8A8078"
   :line-height   "1.65"
   :max-width     (px->rem 520)
   :margin-bottom (px->rem 24)})

;; ── Progress strip ───────────────────────────────────────────────────────────

(o/defstyled progress-strip :div
  :flex :items-center
  {:gap           (px->rem 12)
   :background    "white"
   :border        "1.5px solid #DAD2CE"
   :border-radius (px->rem 12)
   :padding       (str/join " " [(px->rem 14) (px->rem 20)])
   :margin-bottom (px->rem 48)
   :max-width     (px->rem 520)})

(o/defstyled progress-bar-track :div
  :flex-1
  {:height        (px->rem 6)
   :background    t/--hai-white-2
   :border-radius (px->rem 3)
   :overflow      "hidden"})

(o/defstyled progress-bar-fill :div
  {:height        "100%"
   :width         "67%"
   :background    "linear-gradient(90deg, #2BBF9E, #45DCC1)"
   :border-radius (px->rem 3)
   :transition    "width 0.4s ease"})

(o/defstyled progress-text :span
  {:font-size   (px->rem 12)
   :font-weight "700"
   :color       t/--text-secondary
   :white-space "nowrap"})

(o/defstyled progress-sub :span
  {:font-size   (px->rem 11)
   :color       "#8A8078"
   :white-space "nowrap"})

;; ── Ghost-to-purple CTA (must precede moment-card-root) ──────────────────────

(o/defstyled btn-hover-primary :button
  :inline-flex :items-center
  {:gap             (px->rem 6)
   :font-size       (px->rem 12)
   :font-weight     "700"
   :font-family     "inherit"
   :padding         (str/join " " [(px->rem 8) (px->rem 16)])
   :border-radius   (px->rem 8)
   :border          "1.5px solid #DAD2CE"
   :background      "none"
   :color           "#8A8078"
   :cursor          "pointer"
   :min-height      (px->rem 36)
   :text-decoration "none"
   :white-space     "nowrap"
   :transition      "all 0.2s"}
  [#{:&:hover :&:focus}
   {:background   t/--humble-primary
    :border-color t/--humble-primary
    :color        "white"
    :box-shadow   "0 4px 12px rgba(71,5,208,0.25)"}]
  [:&:focus {:outline (str "2px solid " t/--humble-primary) :outline-offset "2px"}]
  [:at-media {:prefers-reduced-motion "reduce"}
   {:transition "none"}
   [#{:&:hover :&:focus} {:box-shadow "none"}]])

;; ── Moment card (hover activates btn-hover-primary) ──────────────────────────

(o/defstyled moment-card-root :div
  {:background    "white"
   :border        "1.5px solid #DAD2CE"
   :border-radius (px->rem 16)
   :overflow      "hidden"
   :transition    "box-shadow 0.2s, border-color 0.2s"}
  [:&:hover {:box-shadow   "0 4px 20px rgba(0,0,0,0.07)"
             :border-color "#C0B8CC"}]
  [:&:hover [btn-hover-primary {:background   t/--humble-primary
                                :border-color t/--humble-primary
                                :color        "white"
                                :box-shadow   "0 4px 12px rgba(71,5,208,0.25)"}]]
  [:&:focus-within [btn-hover-primary {:background   t/--humble-primary
                                       :border-color t/--humble-primary
                                       :color        "white"
                                       :box-shadow   "0 4px 12px rgba(71,5,208,0.25)"}]])

;; ── Timeline container ───────────────────────────────────────────────────────

(o/defstyled timeline-wrapper :div
  {:position     "relative"
   :padding-left (px->rem 48)
   :max-width    (px->rem 900)}
  ["&::before"
   {:content       "''"
    :position      "absolute"
    :left          (px->rem 15)
    :top           (px->rem 24)
    :bottom        (px->rem 40)
    :width         (px->rem 2)
    :background    "#DAD2CE"
    :border-radius (px->rem 1)}])

;; ── "Automate and build" section divider ─────────────────────────────────────

(o/defstyled developer-divider :div
  :flex :items-center
  {:gap      (px->rem 16)
   :margin   (str/join " " [(px->rem 16) "0" (px->rem 40)])
   :position "relative"}
  ["&::before"
   {:content     "'◆'"
    :position    "absolute"
    :left        (px->rem -40)
    :top         "50%"
    :transform   "translateY(-50%)"
    :font-size   (px->rem 8)
    :color       "#DAD2CE"
    :line-height "1"}])

(o/defstyled divider-line :div
  :flex-1
  {:height     (px->rem 1)
   :background "#DAD2CE"})

(o/defstyled divider-label :span
  {:font-size      (px->rem 11)
   :font-weight    "700"
   :text-transform "uppercase"
   :letter-spacing "0.08em"
   :color          "#8A8078"
   :white-space    "nowrap"})

;; ── Moment structural components ─────────────────────────────────────────────

(o/defstyled moment-wrapper :div
  {:position      "relative"
   :margin-bottom (px->rem 48)})

(o/defstyled moment-dot-done :div
  :flex :items-center :justify-center
  {:position      "absolute"
   :left          (px->rem -41)
   :top           (px->rem 20)
   :width         (px->rem 18)
   :height        (px->rem 18)
   :border-radius "50%"
   :background    "#2BBF9E"
   :border        "2px solid #2BBF9E"
   :box-shadow    "0 0 0 3px rgba(43,191,158,0.2)"
   :z-index       "1"}
  ["&::after"
   {:content       "''"
    :width         (px->rem 7)
    :height        (px->rem 7)
    :background    "white"
    :border-radius "50%"
    :display       "block"}])

(o/defstyled moment-dot-pending :div
  :flex :items-center :justify-center
  {:position      "absolute"
   :left          (px->rem -41)
   :top           (px->rem 20)
   :width         (px->rem 18)
   :height        (px->rem 18)
   :border-radius "50%"
   :background    "white"
   :border        (str "2px solid " t/--humble-primary)
   :z-index       "1"}
  ["&::after"
   {:content       "''"
    :width         (px->rem 7)
    :height        (px->rem 7)
    :background    t/--humble-primary
    :border-radius "50%"
    :opacity       "0.5"
    :display       "block"}])

(o/defstyled moment-time :div
  :flex :items-center
  {:font-size      (px->rem 10)
   :font-weight    "700"
   :text-transform "uppercase"
   :letter-spacing "0.08em"
   :color          "#8A8078"
   :margin-bottom  (px->rem 6)
   :gap            (px->rem 8)})

(o/defstyled moment-time-tag :span
  {:background    "#F6F5F0"
   :border-radius (px->rem 4)
   :padding       (str/join " " [(px->rem 2) (px->rem 8)])
   :color         "#8A8078"})

(o/defstyled moment-card-inner :div
  {:display               "grid"
   :grid-template-columns "1fr 320px"
   :width                 "100%"})

(o/defstyled moment-content :div
  :flex :flex-col
  {:padding         (str/join " " [(px->rem 24) (px->rem 28)])
   :justify-content "space-between"
   :gap             (px->rem 16)
   :min-width       "0"})

(o/defstyled moment-scenario :div
  {:font-size      (px->rem 10)
   :font-weight    "700"
   :text-transform "uppercase"
   :letter-spacing "0.08em"
   :color          t/--humble-primary
   :margin-bottom  (px->rem 6)})

(o/defstyled moment-title :div
  {:font-size     (px->rem 17)
   :font-weight   "800"
   :color         t/--hai-dark-purple
   :line-height   "1.25"
   :margin-bottom (px->rem 8)})

(o/defstyled moment-desc :p
  {:font-size   (px->rem 13)
   :color       t/--text-secondary
   :line-height "1.7"
   :font-style  "italic"
   :margin      "0"})

(o/defstyled moment-footer-wrap :div
  :flex :items-center
  {:gap         (px->rem 12)
   :padding-top (px->rem 16)
   :border-top  "1px solid #F6F5F0"
   :flex-wrap   "wrap"})

(o/defstyled moment-preview :div
  :flex :flex-col
  {:background  "#F8F3F0"
   :border-left "1px solid #DAD2CE"
   :padding     (px->rem 20)
   :align-items "stretch"
   :width       (px->rem 320)
   :min-width   (px->rem 320)
   :min-height  (px->rem 200)
   :overflow    "hidden"})

;; ── Benefits strip ───────────────────────────────────────────────────────────

(o/defstyled benefit-strip :div
  :flex :flex-col
  {:margin-top  (px->rem 12)
   :padding-top (px->rem 12)
   :border-top  "1px solid #DAD2CE"})

(o/defstyled benefit-row :div
  :flex
  {:align-items   "flex-start"
   :gap           (px->rem 8)
   :padding       (str/join " " [(px->rem 5) "0"])
   :border-bottom "1px solid #F6F5F0"
   :width         "100%"})

;; ── Preview helpers ──────────────────────────────────────────────────────────

(defn static-tab-strip [left-label right-label]
  [:div {:style {:display "flex" :border "1.5px solid #DAD2CE"
                 :border-radius (px->rem 8) :overflow "hidden"
                 :margin-bottom (px->rem 10) :width "fit-content"}}
   [:div {:style {:font-size (px->rem 11) :font-weight "700"
                  :padding (str/join " " [(px->rem 5) (px->rem 12)])
                  :background "#1E085D" :color "white"
                  :border-right "1.5px solid #DAD2CE"}}
    left-label]
   [:div {:style {:font-size (px->rem 11) :font-weight "700"
                  :padding (str/join " " [(px->rem 5) (px->rem 12)])
                  :background "#F6F5F0" :color "#8A8078"}}
    right-label]])

(defn tab-strip
  "Interactive tab strip. `active` is the current active value (deref'd).
   `on-change` is called with the new value. `tabs` is [{:value kw :label str}]."
  [active on-change tabs]
  (let [last-idx (dec (count tabs))]
    [:div {:style {:display "flex" :border "1.5px solid #DAD2CE"
                   :border-radius (px->rem 8) :overflow "hidden"
                   :margin-bottom (px->rem 10) :width "fit-content"}}
     (map-indexed
      (fn [i {:keys [value label]}]
        ^{:key value}
        [:div {:style    {:font-size    (px->rem 11) :font-weight "700"
                          :padding      (str/join " " [(px->rem 5) (px->rem 12)])
                          :background   (if (= active value) "#1E085D" "#F6F5F0")
                          :color        (if (= active value) "white" "#8A8078")
                          :cursor       "pointer"
                          :user-select  "none"
                          :border-right (when (< i last-idx) "1.5px solid #DAD2CE")}
               :on-click #(on-change value)}
         label])
      tabs)]))

(defn preview-benefits [items]
  [benefit-strip
   (for [[i item] (map-indexed vector items)]
     ^{:key i}
     [benefit-row
      [:span {:style {:color "#2BBF9E" :font-size (px->rem 11)
                      :font-weight "800" :flex-shrink "0" :margin-top (px->rem 1)}}
       "✓"]
      [:span {:style {:font-size (px->rem 12) :color t/--text-secondary
                      :line-height "1.45" :font-weight "500"}}
       item]])])

(defn sched-item [time bg-color border-color text-color title sub]
  [:div {:style {:display "flex" :gap (px->rem 8) :align-items "flex-start"}}
   [:span {:style {:font-size (px->rem 9) :color "#8A8078" :width (px->rem 32)
                   :flex-shrink "0" :padding-top (px->rem 2)}}
    time]
   [:div {:style {:flex "1" :background bg-color
                  :border-left (str "3px solid " border-color)
                  :border-radius (str "0 " (px->rem 5) " " (px->rem 5) " 0")
                  :padding (str/join " " [(px->rem 5) (px->rem 8)])}}
    [:div {:style {:font-size (px->rem 10) :font-weight "700" :color text-color}} title]
    [:div {:style {:font-size (px->rem 9) :color "#8A8078"}} sub]]])

;; ── Preview panels (static for M2) ───────────────────────────────────────────

(defn- m0-your-day []
  [:div {:style {:background "white" :border-radius (px->rem 8)
                 :border "1px solid #DAD2CE" :padding (px->rem 10)
                 :display "flex" :flex-direction "column" :gap (px->rem 5)}}
   [sched-item "9:00"  "#D7E0FF" "#3564FF" "#1D3A6E"          "Team standup"            "30 min · Google Meet"]
   [sched-item "10:00" "#FFF1F5" "#FEBBCC" t/--hai-dark-purple "Review GG-2149 PRD"      "Linear · High priority"]
   [sched-item "11:00" "#DAF8F3" "#45DCC1" "#1A6355"           "Investor call — Acme VC" "45 min · Zoom"]
   [sched-item "14:00" "#FFF4CC" "#FFC600" "#6B4A00"           "Send proposal draft"     "Due today"]])

(defn- m0-team-view []
  [:div {:style {:background "white" :border-radius (px->rem 8)
                 :border "1px solid #DAD2CE" :padding (px->rem 10)
                 :display "flex" :flex-direction "column" :gap (px->rem 8)}}
   (for [[name focus available?]
         [["Jordan" "Proposal review · 10:30"   true]
          ["Sara"   "Client onboarding · 11:00"  false]
          ["Alex"   "No meetings until 2 PM"     true]]]
     ^{:key name}
     [:div {:style {:display "flex" :align-items "center" :gap (px->rem 8)}}
      [:div {:style {:width (px->rem 8) :height (px->rem 8) :border-radius "50%"
                     :background (if available? "#2BBF9E" "#FFC600")
                     :flex-shrink "0"}}]
      [:div
       [:div {:style {:font-size (px->rem 10) :font-weight "700" :color t/--hai-dark-purple}} name]
       [:div {:style {:font-size (px->rem 9) :color "#8A8078"}} focus]]])])

(defn preview-m0 []
  #?(:cljs
     (r/with-let [!tab (r/atom :day)]
       [:<>
        [tab-strip @!tab #(reset! !tab %) [{:value :day :label "Your day"} {:value :team :label "Team view"}]]
        (case @!tab
          :day  [m0-your-day]
          :team [m0-team-view])
        [preview-benefits ["Your whole day, laid out before you start"
                           "Meetings, tasks and priorities — in one place"
                           "Begin focused, not frantic"]]])))

(defn preview-m1 []
  [:<>
   [:div {:style {:background "white" :border-radius (px->rem 8) :border "1px solid #DAD2CE"}}
    [:div {:style {:padding (str/join " " [(px->rem 6) (px->rem 10)])
                   :display "flex" :align-items "center" :gap (px->rem 6)
                   :border-bottom "1px solid #F6F5F0"}}
     [:div {:style {:display "flex" :gap (px->rem 3)}}
      [:div {:style {:width (px->rem 7) :height (px->rem 7) :border-radius "50%" :background "#FF5F57"}}]
      [:div {:style {:width (px->rem 7) :height (px->rem 7) :border-radius "50%" :background "#FFBD2E"}}]
      [:div {:style {:width (px->rem 7) :height (px->rem 7) :border-radius "50%" :background "#28C840"}}]]
     [:div {:style {:flex "1" :background "#F6F5F0" :border-radius (px->rem 4)
                    :padding (str/join " " [(px->rem 2) (px->rem 8)])
                    :font-size (px->rem 9) :color "#8A8078" :font-family "monospace"}}
      "linkedin.com/in/sarah-chen"]]
    [:div {:style {:padding (str/join " " [(px->rem 10) (px->rem 12)])}}
     [:div {:style {:font-size (px->rem 11) :font-weight "700" :color t/--hai-dark-purple :margin-bottom (px->rem 3)}}
      "Sarah Chen — Head of Product"]
     [:div {:style {:font-size (px->rem 9) :color "#8A8078" :line-height "1.5" :margin-bottom (px->rem 8)}}
      "Previously VP Product at TechStart. 8 years B2B SaaS. Based in London..."]
     [:div {:style {:background t/--hai-dark-purple :color "white" :border-radius (px->rem 6)
                    :padding (str/join " " [(px->rem 5) (px->rem 10)])
                    :font-size (px->rem 9) :font-weight "700"
                    :display "inline-flex" :align-items "center" :gap (px->rem 4)}}
      [:svg {:view-box "0 0 24 24" :width "8" :height "8" :fill "none" :stroke "white" :stroke-width "2.5"}
       [:path {:d "M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z"}]]
      "Save to Humble"]]]
   [:div {:style {:background "white" :border "1.5px solid #2BBF9E" :border-radius (px->rem 8)
                  :padding (str/join " " [(px->rem 8) (px->rem 10)])
                  :display "flex" :align-items "center" :gap (px->rem 8)}}
    [:div {:style {:width (px->rem 18) :height (px->rem 18) :border-radius "50%"
                   :background "#DAF8F3" :flex-shrink "0"
                   :display "flex" :align-items "center" :justify-content "center"}}
     [:svg {:view-box "0 0 12 12" :width "9" :height "9" :fill "none" :stroke "#2BBF9E" :stroke-width "2.5"}
      [:polyline {:points "2 6 5 9 10 3"}]]]
    [:div
     [:div {:style {:font-size (px->rem 10) :font-weight "700" :color t/--hai-dark-purple}} "Saved to Humble"]
     [:div {:style {:font-size (px->rem 9) :color "#8A8078"}} "Name, company and role pre-filled"]]]
   [preview-benefits ["Save anything in one click"
                      "No copy-pasting, no context-switching"
                      "Stays in your knowledge — ready when you return"]]])

(defn preview-m2 []
  [:<>
   [:div {:style {:background "white" :border-radius (px->rem 8) :border "1px solid #DAD2CE"}}
    [:div {:style {:padding (str/join " " [(px->rem 6) (px->rem 10)])
                   :display "flex" :align-items "center" :gap (px->rem 6)
                   :border-bottom "1px solid #F6F5F0"}}
     [:div {:style {:display "flex" :gap (px->rem 3)}}
      [:div {:style {:width (px->rem 7) :height (px->rem 7) :border-radius "50%" :background "#FF5F57"}}]
      [:div {:style {:width (px->rem 7) :height (px->rem 7) :border-radius "50%" :background "#FFBD2E"}}]
      [:div {:style {:width (px->rem 7) :height (px->rem 7) :border-radius "50%" :background "#28C840"}}]]
     [:div {:style {:flex "1" :background "#F6F5F0" :border-radius (px->rem 4)
                    :padding (str/join " " [(px->rem 2) (px->rem 8)])
                    :font-size (px->rem 9) :color "#8A8078" :font-family "monospace"}}
      "linkedin.com/in/sarah-chen"]
     [:div {:style {:width (px->rem 20) :height (px->rem 20) :border-radius (px->rem 4)
                    :background "#2BBF9E" :display "flex" :align-items "center" :justify-content "center"}}
      [:span {:style {:color "white" :font-size (px->rem 10) :font-weight "800"}} "H"]]]]
   [:div {:style {:background "white" :border "2px solid #2BBF9E" :border-radius (px->rem 8) :overflow "hidden"}}
    [:div {:style {:background "#2BBF9E" :padding (str/join " " [(px->rem 7) (px->rem 10)])
                   :display "flex" :align-items "center" :gap (px->rem 6)}}
     [:svg {:view-box "0 0 12 12" :width "10" :height "10" :fill "none" :stroke "white" :stroke-width "2.5"}
      [:polyline {:points "2 6 5 9 10 3"}]]
     [:span {:style {:font-size (px->rem 10) :font-weight "700" :color "white"}} "Already in your CRM"]]
    [:div {:style {:padding (str/join " " [(px->rem 8) (px->rem 10)])
                   :display "flex" :flex-direction "column" :gap (px->rem 4)}}
     [:div {:style {:font-size (px->rem 11) :font-weight "700" :color t/--hai-dark-purple}} "Sarah Chen"]
     [:div {:style {:font-size (px->rem 9) :color "#8A8078"}} "Head of Product · Acme Corp"]
     [:div {:style {:height (px->rem 1) :background "#F6F5F0" :margin (str/join " " [(px->rem 3) "0"])}}]
     [:div {:style {:display "flex" :justify-content "space-between" :font-size (px->rem 9)}}
      [:span {:style {:color "#8A8078"}} "Last contact"]
      [:span {:style {:color t/--text-secondary :font-weight "600"}} "3 weeks ago · Jordan"]]
     [:div {:style {:display "flex" :justify-content "space-between" :font-size (px->rem 9)}}
      [:span {:style {:color "#8A8078"}} "Deal stage"]
      [:span {:style {:color t/--text-secondary :font-weight "600"}} "Proposal sent"]]
     [:div {:style {:background "#FFF4CC" :border-radius (px->rem 5)
                    :padding (str/join " " [(px->rem 5) (px->rem 7)])
                    :font-size (px->rem 9) :color "#6B4A00" :margin-top (px->rem 3)}}
      "⚠ Jordan last reached out — check before contacting"]]]
   [preview-benefits ["Know before you reach out — not after"
                      "No logging in, no looking it up"
                      "Your whole team, always on the same account"]]])

(defn preview-m3 []
  [:<>
   [:div {:style {:width "100%" :display "flex" :flex-direction "column"}}
    [:div {:style {:background "#4A154B"
                   :border-radius (str (px->rem 8) " " (px->rem 8) " 0 0")
                   :padding (str/join " " [(px->rem 8) (px->rem 12)])}}
     [:div {:style {:font-size (px->rem 11) :font-weight "700" :color "white"}} "Humble"]
     [:div {:style {:font-size (px->rem 9) :color "rgba(255,255,255,0.6)"}} "Your AI assistant · always available"]]
    [:div {:style {:background "white"
                   :border-radius (str "0 0 " (px->rem 8) " " (px->rem 8))
                   :border "1px solid #DAD2CE" :border-top "none"
                   :padding (px->rem 10) :display "flex" :flex-direction "column" :gap (px->rem 8)}}
     [:div {:style {:display "flex" :gap (px->rem 7)}}
      [:div {:style {:width (px->rem 24) :height (px->rem 24) :border-radius (px->rem 4)
                     :background "#F0E8FF" :color t/--hai-dark-purple
                     :font-size (px->rem 10) :font-weight "700"
                     :display "flex" :align-items "center" :justify-content "center" :flex-shrink "0"}}
       "M"]
      [:div
       [:div {:style {:font-size (px->rem 10) :font-weight "700" :color t/--text-secondary}} "Mahdi"]
       [:div {:style {:font-size (px->rem 10) :color t/--text-secondary :margin-top (px->rem 1)}}
        "Follow up with Sarah re partnership — she mentioned Q2 budget"]]]
     [:div {:style {:background "#DAF8F3" :border-left "3px solid #2BBF9E"
                    :border-radius (str "0 " (px->rem 6) " " (px->rem 6) " 0")
                    :padding (str/join " " [(px->rem 7) (px->rem 10)])
                    :margin-left (px->rem 31) :font-size (px->rem 10)}}
      [:strong {:style {:display "block" :font-weight "700" :color t/--hai-dark-purple}}
       "Saved to your knowledge ✓"]
      "Tagged as follow-up · linked to Sarah Chen"]
     [:div {:style {:display "flex" :gap (px->rem 7)}}
      [:div {:style {:width (px->rem 24) :height (px->rem 24) :border-radius (px->rem 4)
                     :background "#F0E8FF" :color t/--hai-dark-purple
                     :font-size (px->rem 10) :font-weight "700"
                     :display "flex" :align-items "center" :justify-content "center" :flex-shrink "0"}}
       "M"]
      [:div
       [:div {:style {:font-size (px->rem 10) :font-weight "700" :color t/--text-secondary}} "Mahdi"]
       [:div {:style {:font-size (px->rem 10) :color t/--text-secondary :margin-top (px->rem 1)}}
        "What did I note about Sarah last week?"]]]
     [:div {:style {:background "#DAF8F3" :border-left "3px solid #2BBF9E"
                    :border-radius (str "0 " (px->rem 6) " " (px->rem 6) " 0")
                    :padding (str/join " " [(px->rem 7) (px->rem 10)])
                    :margin-left (px->rem 31) :font-size (px->rem 10)}}
      [:strong {:style {:display "block" :font-weight "700" :color t/--hai-dark-purple}}
       "From your notes"]
      "\"Partnership call — she's interested, revisit in Q2 when budget confirmed\""]]]
   [preview-benefits ["Capture thoughts the moment they happen"
                      "Searchable, stored — not scattered in a thread"
                      "Humble remembers it — even when you forget"]]])

(defn- m4-live []
  [:div {:style {:width "100%" :display "flex" :flex-direction "column"}}
   [:div {:style {:background "#4A154B"
                  :border-radius (str (px->rem 8) " " (px->rem 8) " 0 0")
                  :padding (str/join " " [(px->rem 6) (px->rem 10)])
                  :display "flex" :align-items "center" :gap (px->rem 6)}}
    [:span {:style {:font-size (px->rem 12) :color "rgba(255,255,255,0.5)"}} "#"]
    [:span {:style {:font-size (px->rem 10) :font-weight "700" :color "white"}} "finance"]]
   [:div {:style {:background "white" :border "1px solid #DAD2CE" :border-top "none"
                  :border-radius (str "0 0 " (px->rem 8) " " (px->rem 8))
                  :padding (px->rem 10) :display "flex" :flex-direction "column" :gap (px->rem 8)}}
    [:div {:style {:background "#F6F5F0" :border "1px solid #DAD2CE"
                   :border-radius (px->rem 6) :padding (str/join " " [(px->rem 8) (px->rem 10)])
                   :display "flex" :align-items "center" :gap (px->rem 8)
                   :margin-left (px->rem 31)}}
     [:div {:style {:width (px->rem 28) :height (px->rem 28) :background "#D7E0FF"
                    :border-radius (px->rem 6) :display "flex" :align-items "center"
                    :justify-content "center" :flex-shrink "0" :font-size (px->rem 12)}}
      "📄"]
     [:div
      [:div {:style {:font-size (px->rem 10) :font-weight "700" :color t/--text-secondary}}
       "invoice_2024_0847.pdf"]
      [:div {:style {:font-size (px->rem 9) :color "#8A8078"}} "PDF · 84 KB"]]]
    [:div {:style {:background "#FFF4CC" :border-left "3px solid #FFC600"
                   :border-radius (str "0 " (px->rem 6) " " (px->rem 6) " 0")
                   :padding (str/join " " [(px->rem 7) (px->rem 10)])
                   :font-size (px->rem 10) :margin-left (px->rem 31)}}
     "⚡ Humble is reading this invoice..."]
    [:div {:style {:background "#DAF8F3" :border-left "3px solid #2BBF9E"
                   :border-radius (str "0 " (px->rem 6) " " (px->rem 6) " 0")
                   :padding (str/join " " [(px->rem 7) (px->rem 10)])
                   :font-size (px->rem 10) :margin-left (px->rem 31)}}
     [:strong {:style {:display "block" :font-weight "700" :color t/--hai-dark-purple}}
      "Invoice processed ✓"]
     [:div {:style {:display "flex" :gap (px->rem 6) :margin-top (px->rem 4) :flex-wrap "wrap"}}
      (for [tag ["Acme Ltd" "£2,400.00" "Due 30 Jan" "INV-0847"]]
        ^{:key tag}
        [:span {:style {:font-size (px->rem 9) :background "white"
                        :border-radius (px->rem 4)
                        :padding (str/join " " [(px->rem 2) (px->rem 6)])}}
         tag])]]]])

(defn- m4-history []
  [:div {:style {:display "flex" :flex-direction "column" :gap (px->rem 6)}}
   (for [[doc label]
         [["invoice_2024_0847.pdf"   "Today 09:14 · #finance"]
          ["contract_draft_v3.docx"  "Yesterday 16:22 · #legal"]
          ["expenses_march.xlsx"     "Mon 11:05 · #finance"]]]
     ^{:key doc}
     [:div {:style {:background "white" :border "1px solid #DAD2CE" :border-radius (px->rem 8)
                    :padding (str/join " " [(px->rem 8) (px->rem 10)])
                    :display "flex" :align-items "center" :gap (px->rem 8)}}
      [:div {:style {:width (px->rem 24) :height (px->rem 24) :border-radius (px->rem 4)
                     :background "#DAF8F3" :display "flex" :align-items "center"
                     :justify-content "center" :flex-shrink "0"}}
       [:svg {:view-box "0 0 12 12" :width "9" :height "9" :fill "none"
              :stroke "#2BBF9E" :stroke-width "2.5"}
        [:polyline {:points "2 6 5 9 10 3"}]]]
      [:div {:style {:flex "1" :min-width "0"}}
       [:div {:style {:font-size (px->rem 10) :font-weight "700" :color t/--hai-dark-purple
                      :white-space "nowrap" :overflow "hidden" :text-overflow "ellipsis"}} doc]
       [:div {:style {:font-size (px->rem 9) :color "#8A8078"}} label]]])])

(defn preview-m4 []
  #?(:cljs
     (r/with-let [!tab (r/atom :live)]
       [:<>
        [tab-strip @!tab #(reset! !tab %) [{:value :live :label "Live"} {:value :history :label "History"}]]
        (case @!tab
          :live    [m4-live]
          :history [m4-history])
        [preview-benefits ["Nothing processed manually — Humble handles it"
                           "Any channel, any document — you set the rules"
                           "Done before anyone has to ask"]]])))

(defn- m5-embed []
  [:div {:style {:background "#0D1117" :border-radius (px->rem 8)
                 :padding (str/join " " [(px->rem 14) (px->rem 16)])
                 :font-family "'Courier New', monospace"
                 :font-size (px->rem 10) :line-height "1.8"}}
   [:div {:style {:color "#6A9955"}} "<!-- Drop into any webpage -->"]
   [:div {:style {:color "#D4D4D4"}}
    "<" [:span {:style {:color "#569CD6"}} "script"]]
   [:div {:style {:color "#D4D4D4"}}
    "\u00a0\u00a0" [:span {:style {:color "#9CDCFE"}} "src"] "="
    [:span {:style {:color "#CE9178"}} "\"https://cdn.humble.ai/chat.js\""]]
   [:div {:style {:color "#D4D4D4"}}
    "\u00a0\u00a0" [:span {:style {:color "#9CDCFE"}} "data-key"] "="
    [:span {:style {:color "#CE9178"}} "\"hum_An...A03\""]]
   [:div {:style {:color "#D4D4D4"}}
    "\u00a0\u00a0" [:span {:style {:color "#9CDCFE"}} "data-assistant"] "="
    [:span {:style {:color "#CE9178"}} "\"support\""]]
   [:div {:style {:color "#D4D4D4"}}
    "></" [:span {:style {:color "#569CD6"}} "script"] ">"]
   [:div {:style {:margin-top (px->rem 8) :padding-top (px->rem 8)
                  :border-top "1px solid #30363D"}}
    [:div {:style {:color "#2BBF9E"}} "// \u2713 Chat widget appears bottom-right"]
    [:div {:style {:margin-top (px->rem 6) :background "#161B22" :border-radius (px->rem 6)
                   :padding (px->rem 8) :display "flex"
                   :align-items "flex-end" :justify-content "flex-end"}}
     [:div {:style {:background t/--humble-primary :color "white"
                    :border-radius (str (px->rem 12) " " (px->rem 12) " " (px->rem 2) " " (px->rem 12))
                    :padding (str/join " " [(px->rem 6) (px->rem 10)])
                    :font-size (px->rem 9) :max-width "80%"}}
      "How can I help you today?"]]]])

(defn- m5-rest []
  [:div {:style {:background "#0D1117" :border-radius (px->rem 8)
                 :padding (str/join " " [(px->rem 14) (px->rem 16)])
                 :font-family "'Courier New', monospace"
                 :font-size (px->rem 10) :line-height "1.8"}}
   [:div {:style {:color "#6A9955"}} "# Query your Humble knowledge base"]
   [:div {:style {:color "#D4D4D4"}}
    [:span {:style {:color "#569CD6"}} "curl"] " -X POST \\"]
   [:div {:style {:color "#CE9178" :padding-left (px->rem 12)}}
    "https://api.humble.ai/v1/query \\"]
   [:div {:style {:color "#D4D4D4" :padding-left (px->rem 12)}}
    "-H " [:span {:style {:color "#CE9178"}} "\"Authorization: Bearer hum_An...\""]]
   [:div {:style {:color "#D4D4D4" :padding-left (px->rem 12)}}
    "-d " [:span {:style {:color "#CE9178"}} "'{\"q\": \"Sarah Chen last contact\"}'"]]])

(defn preview-m5 []
  #?(:cljs
     (r/with-let [!tab (r/atom :embed)]
       [:<>
        [tab-strip @!tab #(reset! !tab %) [{:value :embed :label "Embed"} {:value :rest :label "REST"}]]
        (case @!tab
          :embed [m5-embed]
          :rest  [m5-rest])
        [preview-benefits ["Embed Humble into any product or workflow"
                           "Query, push, automate — no limits"
                           "Ship faster — Humble handles the intelligence layer"]]])))

(defn- m6-stats [heading rows]
  [:div {:style {:display "flex" :flex-direction "column" :gap (px->rem 6)}}
   [:div {:style {:display "flex" :align-items "center" :justify-content "space-between"}}
    [:span {:style {:font-size (px->rem 10) :font-weight "700" :color t/--hai-dark-purple}} heading]
    [:span {:style {:font-size (px->rem 9) :color "#8A8078" :background "#F6F5F0"
                    :padding (str/join " " [(px->rem 2) (px->rem 8)]) :border-radius (px->rem 4)}}
     "31 Mar – 4 Apr"]]
   [:div {:style {:display "grid" :grid-template-columns "1fr 1fr" :gap (px->rem 6)}}
    (for [[n label delta delta-color] rows]
      ^{:key label}
      [:div {:style {:background "white" :border "1px solid #DAD2CE"
                     :border-radius (px->rem 8) :padding (px->rem 10)}}
       [:div {:style {:font-size (px->rem 18) :font-weight "800" :color t/--hai-dark-purple}} n]
       [:div {:style {:font-size (px->rem 9) :color "#8A8078" :margin-top (px->rem 2)}} label]
       [:div {:style {:font-size (px->rem 9) :color delta-color :margin-top (px->rem 2)}} delta]])]])

(defn preview-m6 []
  #?(:cljs
     (r/with-let [!tab (r/atom :mine)]
       [:<>
        [tab-strip @!tab #(reset! !tab %) [{:value :mine :label "My progress"} {:value :team :label "Team progress"}]]
        (case @!tab
          :mine [m6-stats "Your week"
                 [[6  "Tickets closed"  "↑ 2 vs last week"    "#2BBF9E"]
                  [14 "Notes captured"  "↑ 5 vs last week"    "#2BBF9E"]
                  [4  "Meetings held"   "— same as last week"  "#8A8078"]
                  [3  "CRM updates"     "↑ 1 vs last week"    "#2BBF9E"]]]
          :team [m6-stats "Team this week"
                 [[28 "Tickets closed"  "↑ 9 vs last week"    "#2BBF9E"]
                  [61 "Notes captured"  "↑ 18 vs last week"   "#2BBF9E"]
                  [17 "Meetings held"   "— same as last week"  "#8A8078"]
                  [12 "CRM updates"     "↑ 3 vs last week"    "#2BBF9E"]]])
        [preview-benefits ["See everything your team has shipped — in one place"
                           "No chasing for updates across tools and teams"
                           "The week's story — without a meeting about it"]]])))

;; ── Closing CTA ──────────────────────────────────────────────────────────────

(o/defstyled closing-cta :div
  {:background    "#1E085D"
   :border-radius (px->rem 16)
   :padding       (str/join " " [(px->rem 40) (px->rem 48)])
   :margin-top    (px->rem 48)
   :max-width     (px->rem 852)})

(o/defstyled closing-cta-eyebrow :div
  {:font-size      (px->rem 11)
   :font-weight    "700"
   :text-transform "uppercase"
   :letter-spacing "0.1em"
   :color          "#FEBBCC"
   :margin-bottom  (px->rem 14)})

(o/defstyled closing-cta-title :h2
  {:font-size   (px->rem 28)
   :font-weight "800"
   :color       "white"
   :margin      "0 0 16px"
   :line-height "1.2"})

(o/defstyled closing-cta-lead :p
  {:font-size   (px->rem 14)
   :color       "rgba(255,255,255,0.72)"
   :line-height "1.65"
   :margin      "0 0 32px"
   :max-width   (px->rem 500)})

(o/defstyled closing-cta-book-btn :a
  :inline-flex :items-center
  {:gap           (px->rem 10)
   :background    "#4705D0"
   :color         "white"
   :font-size     (px->rem 15)
   :font-weight   "700"
   :padding       (str/join " " [(px->rem 14) (px->rem 24)])
   :border-radius (px->rem 12)
   :text-decoration "none"
   :cursor        "pointer"
   :transition    "background 0.2s, box-shadow 0.2s"}
  [:&:hover {:background "#3A04A8"
             :box-shadow "0 6px 20px rgba(71,5,208,0.45)"}]
  [:svg {:width (px->rem 16) :height (px->rem 16) :flex-shrink "0"}])

(o/defstyled closing-cta-response :div
  {:font-size   (px->rem 12)
   :color       "rgba(255,255,255,0.45)"
   :margin-top  (px->rem 12)})

;; ── Chrome extension modal ────────────────────────────────────────────────────

#?(:cljs
   (defn chrome-extension-modal [!open]
     [c/DialogRoot {:open @!open :onOpenChange #(reset! !open %)}
      [c/DialogContent {:max-width "440px"}
       [c/DialogTitle "Add Humble to Chrome"]
       [:div {:style {:display "flex" :flex-direction "column"
                      :gap (px->rem 12) :margin-top (px->rem 8)}}
        (for [[step desc]
              [[1 "Click \"Add to Chrome\" on the Chrome Web Store"]
               [2 "Pin the Humble extension to your toolbar"]
               [3 "Sign in with your Humble account"]
               [4 "Browse any page — Humble appears automatically"]]]
          ^{:key step}
          [:div {:style {:display "flex" :gap (px->rem 12) :align-items "flex-start"}}
           [:div {:style {:width         (px->rem 20) :height     (px->rem 20)
                          :border-radius "50%"        :flex-shrink "0"
                          :background    "#1E085D"    :color       "white"
                          :font-size     (px->rem 10) :font-weight "700"
                          :display       "flex"       :align-items "center"
                          :justify-content "center"}}
            step]
           [:div {:style {:font-size (px->rem 13) :color "#1D2939" :line-height "1.5"
                          :padding-top (px->rem 1)}} desc]])]
       [c/Flex {:justify "end" :gap "3" :mt "4"}
        [c/DialogClose [c/Button {:variant "soft" :autoFocus true} "Maybe later"]]
        [c/Button {:variant  "solid"
                   :on-click #(js/window.open install/chrome-store-url "_blank")}
         "Add to Chrome"]]]]))

;; ── Slack modal ───────────────────────────────────────────────────────────────

#?(:cljs
   (defn slack-modal [!open]
     [c/DialogRoot {:open @!open :onOpenChange #(reset! !open %)}
      [c/DialogContent {:max-width "440px"}
       [c/DialogTitle "Add Humble to Slack"]
       [:div {:style {:display "flex" :flex-direction "column"
                      :gap (px->rem 12) :margin-top (px->rem 8)}}
        (for [[step desc]
              [[1 "Click \"Add to Slack\" to open the install page"]
               [2 "Choose your Slack workspace and click Allow"]
               [3 "Humble will appear as a bot in your workspace"]
               [4 "Send a voice note or message to capture a thought instantly"]]]
          ^{:key step}
          [:div {:style {:display "flex" :gap (px->rem 12) :align-items "flex-start"}}
           [:div {:style {:width         (px->rem 20) :height     (px->rem 20)
                          :border-radius "50%"        :flex-shrink "0"
                          :background    "#1E085D"    :color       "white"
                          :font-size     (px->rem 10) :font-weight "700"
                          :display       "flex"       :align-items "center"
                          :justify-content "center"}}
            step]
           [:div {:style {:font-size (px->rem 13) :color "#1D2939" :line-height "1.5"
                          :padding-top (px->rem 1)}} desc]])]
       [c/Flex {:justify "end" :gap "3" :mt "4"}
        [c/DialogClose [c/Button {:variant "soft" :autoFocus true} "Maybe later"]]
        [c/Button {:variant  "solid"
                   :on-click #(js/window.open "/chat/slack/v1/A05KNFGBWGL/install" "_blank")}
         "Add to Slack"]]]]))

;; ── CRM modal ────────────────────────────────────────────────────────────────

#?(:cljs
   (defn crm-modal [!open !tool]
     (let [tool       @!tool
           tool-label (case tool "hubspot" "HubSpot" "notion" "Notion" "airtable" "Airtable" "your CRM")]
       [c/DialogRoot {:open @!open :onOpenChange #(reset! !open %)}
        [c/DialogContent {:max-width "440px"}
         [c/DialogTitle (str "Connect " tool-label)]
         [:div {:style {:display "flex" :flex-direction "column"
                        :gap (px->rem 12) :margin-top (px->rem 8)}}
          (for [[step desc]
                [[1 (str "Click \"Connect " tool-label "\" below")]
                 [2 "Authenticate with your account"]
                 [3 "Humble syncs your contacts and interaction history"]
                 [4 "Browse any contact — Humble shows their full history in context"]]]
            ^{:key step}
            [:div {:style {:display "flex" :gap (px->rem 12) :align-items "flex-start"}}
             [:div {:style {:width         (px->rem 20) :height     (px->rem 20)
                            :border-radius "50%"        :flex-shrink "0"
                            :background    "#1E085D"    :color       "white"
                            :font-size     (px->rem 10) :font-weight "700"
                            :display       "flex"       :align-items "center"
                            :justify-content "center"}}
              step]
             [:div {:style {:font-size (px->rem 13) :color "#1D2939" :line-height "1.5"
                            :padding-top (px->rem 1)}} desc]])]
         [c/Flex {:justify "end" :gap "3" :mt "4"}
          [c/DialogClose [c/Button {:variant "soft" :autoFocus true} "Maybe later"]]
          [c/Button {:variant  "solid"
                     :on-click #(do (reset! !open false)
                                    (set! js/window.location.href
                                          (str "/app/connections/create/" tool)))}
           (str "Connect " tool-label)]]]])))

;; ── Split button (My Humble Assistant tab) ──────────────────────────────────

(def expand-icon (icons/mui-icon :outlined :expand_more))

(o/defstyled split-btn-wrapper :div
  {:position "relative" :display "inline-flex" :flex-shrink "0"})

(o/defstyled split-btn-primary :button
  :cursor-pointer
  {:display "inline-flex" :align-items "center" :gap (px->rem 6)
   :background t/--humble-primary-dark :color "white"
   :font-size (px->rem 12) :font-weight "700"
   :padding (str/join " " [(px->rem 9) (px->rem 14)])
   :border-radius (str (px->rem 8) " 0 0 " (px->rem 8))
   :border "none"})

(o/defstyled split-btn-chevron :button
  :cursor-pointer
  {:display "inline-flex" :align-items "center" :justify-content "center"
   :background t/--humble-primary-dark :color "white"
   :padding (str/join " " [(px->rem 9) (px->rem 10)])
   :border-left "1px solid rgba(255,255,255,0.2)"
   :border-top "none" :border-right "none" :border-bottom "none"
   :border-radius (str "0 " (px->rem 8) " " (px->rem 8) " 0")})

(o/defstyled split-btn-dropdown :div
  {:position "absolute" :top "calc(100% + 6px)" :right "0"
   :background "white" :border "1px solid #DAD2CE"
   :border-radius (px->rem 8) :overflow "hidden"
   :box-shadow "0 4px 16px rgba(0,0,0,0.10)"
   :min-width (px->rem 180) :z-index "50"})

(o/defstyled split-btn-option :div
  :cursor-pointer
  {:display "flex" :align-items "center"
   :padding (str/join " " [(px->rem 10) (px->rem 14)])
   :font-size (px->rem 12) :font-weight "600"}
  [:&:hover {:background-color t/--hai-white-2}])

#?(:cljs
   (defn split-button
     "Split button: primary action on left, dropdown chevron on right.
      props: {:primary-label :primary-action :dropdown-items [{:label :action}]}"
     [{:keys [primary-label primary-action dropdown-items]}]
     (r/with-let [!open? (r/atom false)]
       [split-btn-wrapper
        [split-btn-primary {:on-click primary-action}
         [icons/plus {:width 12 :height 12 :fill "white"}]
         primary-label]
        [split-btn-chevron {:on-click #(swap! !open? not)}
         [expand-icon]]
        (when @!open?
          [split-btn-dropdown
           (for [{:keys [label action]} dropdown-items]
             [split-btn-option {:key label :on-click action}
              label])])])))

;; ── Skills card illustrations ────────────────────────────────────────────────

(o/defstyled illus-panel :div
  :flex :flex-col
  {:gap (px->rem 8) :padding (px->rem 16)})

(o/defstyled chat-bubble :div
  {:padding (str/join " " [(px->rem 8) (px->rem 12)])
   :border-radius (px->rem 12)
   :font-size (px->rem 11)
   :max-width (px->rem 145)
   :line-height "1.4"})

(defn assistants-illustration []
  [illus-panel
   [chat-bubble {:style {:background "white" :align-self "flex-end" :color "#1E085D"}}
    "How do I reset my password?"]
   [chat-bubble {:style {:background "#4705D0" :color "white"}}
    "Sure! Click ‘Forgot password’ on the login page."]
   [chat-bubble {:style {:background "white" :color "#999" :letter-spacing "0.2em"}}
    "···"]])

(o/defstyled browser-window :div
  {:background "white" :border-radius (px->rem 8)
   :box-shadow "0 2px 12px rgba(0,0,0,0.10)"
   :overflow "hidden" :width (px->rem 175)})

(o/defstyled browser-toolbar :div
  :flex :items-center
  {:background "#f0f0f0" :padding (str/join " " [(px->rem 6) (px->rem 10)])
   :gap (px->rem 4)})

(o/defstyled browser-dot :div
  {:width (px->rem 8) :height (px->rem 8) :border-radius "50%"})

(o/defstyled browser-body :div
  {:padding (px->rem 12) :font-size (px->rem 11) :color "#333"})

(defn mini-apps-illustration []
  [browser-window
   [browser-toolbar
    [browser-dot {:style {:background "#FF5F57"}}]
    [browser-dot {:style {:background "#FFBD2E"}}]
    [browser-dot {:style {:background "#28C840"}}]]
   [browser-body
    [:div {:style {:margin-bottom (px->rem 8) :color "#555"}} "Current page"]
    [:div {:style {:background "#4705D0" :color "white"
                   :padding "5px 10px"
                   :border-radius (px->rem 4)
                   :font-size (px->rem 10)
                   :display "inline-block"}}
     "Save to Humble"]]])

;; ── Skills grid ──────────────────────────────────────────────────────────────

(o/defstyled skills-grid :div
  {:display "grid"
   :grid-template-columns "1fr 1fr"
   :gap (px->rem 16)})

(o/defstyled section-card :div
  :cursor-pointer
  {:display "grid"
   :grid-template-columns (str (px->rem 200) " 1fr")
   :border-radius (px->rem 16)
   :border "1px solid #DAD2CE"
   :background "white"
   :overflow "hidden"
   :transition "box-shadow 0.15s ease"}
  [:&:hover {:box-shadow "0 4px 16px rgba(0,0,0,0.08)"}]
  [:.illus {:display "flex" :align-items "center" :justify-content "center"
            :min-height (px->rem 160)}]
  [:.content {:padding (px->rem 24) :display "flex" :flex-direction "column"
              :gap (px->rem 6)}]
  [:.card-header :flex :items-center {:gap (px->rem 8) :margin-bottom (px->rem 4)}]
  [:.card-title {:font-size (px->rem 17) :font-weight "700" :color "#1E085D"}]
  [:.card-beta {:background "#EDE5FF" :border "1px solid #C9B3FF" :color "#4705D0"
                :font-size (px->rem 10) :font-weight "700"
                :padding "2px 7px" :border-radius (px->rem 4) :text-transform "uppercase"}]
  [:.card-desc {:font-size (px->rem 13) :color "#5C5555" :line-height "1.55" :flex-grow "1"}]
  [:.card-footer {:margin-top (px->rem 12) :font-size (px->rem 13)
                  :color "#4705D0" :font-weight "600"}])

#?(:cljs
   (defn skills-section-card
     [{:keys [title description illus-bg illus-content route beta?]}]
     [section-card
      {:on-click #(>e [:routing/navigate [route]])}
      [:div.illus {:style {:background illus-bg}}
       illus-content]
      [:div.content
       [:div.card-header
        [:span.card-title title]
        (when beta? [:span.card-beta "BETA"])]
       [:p.card-desc description]
       [:span.card-footer (str "Open " title " →")]]]))

(o/defstyled skills-lead-row :div
  :flex :items-start :justify-between
  {:margin-bottom (px->rem 32) :gap (px->rem 24)})

;; ── Page ─────────────────────────────────────────────────────────────────────

(defn setup-page [_]
  #?(:cljs
     (r/with-let [!chrome-open (r/atom false)
                  !slack-open  (r/atom false)
                  !crm-open    (r/atom false)
                  !crm-tool    (r/atom nil)]
       [layout/page
        [layout/breadcrumbs]
        [c/TabsRoot {:defaultValue "day"}
         [c/TabsList
          [c/TabsTrigger {:value "day"} "A day with Humble"]
          [c/TabsTrigger {:value "skills"} "My Humble Assistant"]]

         [c/TabsContent {:value "day"}
          [title-row
           [title-icon-group
            [:svg {:view-box "0 0 24 24" :width "28" :height "28"
                   :fill "none" :stroke t/--hai-dark-purple :stroke-width "2"}
             [:path {:d "M22 11.08V12a10 10 0 11-5.93-9.14"}]
             [:polyline {:points "22 4 12 14.01 9 11.01"}]]
            [page-title "A day with Humble"]]
           [book-a-call {:href   "https://calendly.com/mahdi-humbleai/start-your-ai-journey"
                         :target "_blank"}
            [:svg {:view-box "0 0 24 24" :width "13" :height "13"
                   :fill "none" :stroke "currentColor" :stroke-width "2"}
             [:rect {:x "3" :y "4" :width "18" :height "18" :rx "2"}]
             [:line {:x1 "16" :y1 "2" :x2 "16" :y2 "6"}]
             [:line {:x1 "8" :y1 "2" :x2 "8" :y2 "6"}]
             [:line {:x1 "3" :y1 "10" :x2 "21" :y2 "10"}]]
            "Book a call"]]
          [page-lead "Humble fits into the moments you already have — not the other way around. Here's how it shows up across your day."]
          [layout/content
           [timeline-wrapper
            [moment-wrapper {:style {:margin-bottom "56px"}}
             [moment-dot-done]
             [moment-time [moment-time-tag "8:00 AM"] " Before anything else"]
             [moment-card-root {:tab-index "0"}
              [moment-card-inner
               [moment-content
                [:div
                 [moment-scenario "Your morning briefing"]
                 [moment-title "See your whole day before it starts"]
                 [moment-desc "Open the Humble Timeline and your day is already laid out — meetings blocked, tasks queued, priorities surfaced. Everything from your calendar, Linear and Slack in one view."]]
                [moment-footer-wrap
                 [:div {:style {:display "flex" :flex-direction "column" :gap (px->rem 8) :align-items "flex-start"}}
                  [btn-hover-primary {:on-click #(set! js/window.location.href "/app/connections/new")} "Connect your calendar"]
                  [:a {:href "/app/timelines"
                       :style {:font-size (px->rem 12) :color "#8A8078" :text-decoration "none"
                               :cursor "pointer"}}
                   "or open your Timeline →"]]]]
               [moment-preview [preview-m0]]]]]
            [moment-wrapper {:style {:margin-bottom "28px"}}
             [moment-dot-done]
             [moment-time [moment-time-tag "9:30 AM"] " Deep work at your desk"]
             [moment-card-root {:tab-index "0"}
              [moment-card-inner
               [moment-content
                [:div
                 [moment-scenario "While you research"]
                 [moment-title "Save what you find — without losing your train of thought"]
                 [moment-desc "You're deep in research. A profile catches your eye — this person matters. You want to save it before the tab disappears and the moment is gone."]]
                [moment-footer-wrap
                 [btn-hover-primary {:on-click #(reset! !chrome-open true)} "Add to browser"]]]
               [moment-preview [preview-m1]]]]]
            [moment-wrapper {:style {:margin-bottom "72px"}}
             [moment-dot-done]
             [moment-time [moment-time-tag "9:45 AM"] " Team context, instantly"]
             [moment-card-root {:tab-index "0"}
              [moment-card-inner
               [moment-content
                [:div
                 [moment-scenario "Know before you reach out"]
                 [moment-title "Is this person already in your CRM?"]
                 [moment-desc "You're about to reach out to someone. Before you type, a thought: has anyone on the team already spoken to them? You don't want to be the third person this week to send the same intro email."]]
                [moment-footer-wrap
                 [:div
                  [:div {:style {:font-size (px->rem 10) :font-weight "700" :text-transform "uppercase"
                                 :letter-spacing "0.07em" :color "#8A8078" :margin-bottom (px->rem 8)}}
                   "Works with your existing tools"]
                  [:div {:style {:display "flex" :gap (px->rem 6) :align-items "center" :flex-wrap "wrap"}}
                   (for [[label source-type] [["HubSpot" "hubspot"] ["Notion" "notion"] ["Airtable" "airtable"]]]
                     ^{:key label}
                     [:button {:style    {:display "inline-flex" :align-items "center"
                                          :font-size (px->rem 11) :font-weight "600" :color "#4705D0"
                                          :border "1.5px solid #4705D0" :border-radius (px->rem 7)
                                          :padding (str/join " " [(px->rem 5) (px->rem 10)])
                                          :background "white" :cursor "pointer"}
                               :on-click #(do (reset! !crm-tool source-type)
                                              (reset! !crm-open true))}
                      label])]]]]
               [moment-preview [preview-m2]]]]]
            [moment-wrapper {:style {:margin-bottom "56px"}}
             [moment-dot-done]
             [moment-time [moment-time-tag "12:30 PM"] " On your phone"]
             [moment-card-root {:tab-index "0"}
              [moment-card-inner
               [moment-content
                [:div
                 [moment-scenario "On the go"]
                 [moment-title "A thought hits. Don't lose it."]
                 [moment-desc "You're walking between meetings. Something just clicked — an idea, a follow-up, a name you need to remember. Your hands are full. You have about 30 seconds before the next thing starts."]]
                [moment-footer-wrap [btn-hover-primary {:on-click #(reset! !slack-open true)} "Add to Slack"]]]
               [moment-preview [preview-m3]]]]]
            [developer-divider
             [divider-line]
             [divider-label "Automate and build"]
             [divider-line]]
            [moment-wrapper {:style {:margin-bottom "56px"}}
             [moment-dot-pending]
             [moment-time [moment-time-tag "2:00 PM"] " Repetitive tasks"]
             [moment-card-root {:tab-index "0"}
              [moment-card-inner
               [moment-content
                [:div
                 [moment-scenario "Automate the manual stuff"]
                 [moment-title "Drop a file in Slack. Humble does the rest."]
                 [moment-desc "An invoice lands in Slack. Someone will need to open it, pull out the key numbers, and log them somewhere. That someone is always the same person. It takes five minutes each time."]]
                [moment-footer-wrap [btn-hover-primary {:on-click #(js/window.open "/app/getting-started" "_blank")} "Explore task library"]]]
               [moment-preview [preview-m4]]]]]
            [moment-wrapper {:style {:margin-bottom "48px"}}
             [moment-dot-pending]
             [moment-time [moment-time-tag "Anytime"] " For developers"]
             [moment-card-root {:tab-index "0"}
              [moment-card-inner
               [moment-content
                [:div
                 [moment-scenario "Build your own"]
                 [moment-title "Bring Humble into anything you're building"]
                 [moment-desc "You've built something. Or you're building it. And you keep thinking: what if this could tap into everything the team already knows? What if you didn't have to rebuild that from scratch?"]]
                [moment-footer-wrap [btn-hover-primary {:on-click #(js/window.open "/app/connections/api-keys/new" "_blank")} "Get your API key"]]]
               [moment-preview [preview-m5]]]]]
            [moment-wrapper {:style {:margin-bottom "0"}}
             [moment-dot-done]
             [moment-time [moment-time-tag "Friday PM"] " Wind down and reflect"]
             [moment-card-root {:tab-index "0"}
              [moment-card-inner
               [moment-content
                [:div
                 [moment-scenario "Progress at a glance"]
                 [moment-title "See what your team actually got done"]
                 [moment-desc "It's Friday afternoon. You want to know what actually moved this week — not the version everyone writes in the standup, but what genuinely progressed across Linear, meetings, CRM, Slack."]]
                [moment-footer-wrap
                 [:div {:style {:display "flex" :flex-direction "column" :gap (px->rem 8) :align-items "flex-start"}}
                  [btn-hover-primary {:on-click #(set! js/window.location.href "/app/connections")} "Connect your tools"]
                  [:a {:href "/app/timelines"
                       :style {:font-size (px->rem 12) :color "#8A8078" :text-decoration "none"
                               :cursor "pointer"}}
                   "or open your Timeline →"]]]]
               [moment-preview [preview-m6]]]]]]
           [closing-cta
            [closing-cta-eyebrow "Want a guided walkthrough?"]
            [closing-cta-title "We’ll set up Humble with you, not for you."]
            [closing-cta-lead "Book a call with Mahdi. We’ll walk through your workflow, connect the right tools and make sure Humble is actually useful from day one — not just installed."]
            [closing-cta-book-btn {:href   "https://calendly.com/mahdi-humbleai/start-your-ai-journey"
                                   :target "_blank"}
             [:svg {:view-box "0 0 24 24" :width "16" :height "16" :fill "currentColor"}
              [:path {:d "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"}]]
             "Book a call with Mahdi →"]]]]

         [c/TabsContent {:value "skills"}
          [layout/heading {:label "My Humble Assistant" :icon icons/outlined-psychology}]
          [skills-lead-row
           [layout/lead "Chat with AI, manage your assistant roles, run mini-apps, and automate repetitive work. Everything your Humble assistant can do for you, in one place."]
           [split-button
            {:primary-label  "Create an assistant"
             :primary-action #(>e [:assistant/create {}])
             :dropdown-items []}]]
          [layout/content
           [skills-grid
            [skills-section-card
             {:title         "Assistant Roles"
              :description   "Trained personas that answer questions, search your documents and support your workflows."
              :illus-bg      "#EDE5FF"
              :illus-content [assistants-illustration]
              :route         :tasks/knowledge}]
            [skills-section-card
             {:title         "Mini-apps"
              :description   "Browser tools that work alongside you. Capture, summarise or save while on any page."
              :illus-bg      "#DAF8F3"
              :illus-content [mini-apps-illustration]
              :route         :admin-ui/mini-apps}]]]]]

        [chrome-extension-modal !chrome-open]
        [slack-modal !slack-open]
        [crm-modal !crm-open !crm-tool]])))

;; ── Route ────────────────────────────────────────────────────────────────────

(defn routes []
  [["/setup"
    {:name  :admin-ui/setup
     ;; fully-qualified rather than ::routing/window-title to avoid wiring the
     ;; alias into this .cljc's reader-conditional requires; same keyword value.
     :hai.web-app.routing/window-title "Set up Humble"
     :label "Get set up"
     :view  setup-page}]])
